/** The `sheet_name` an alternative investment's month row carries. */
export const altSheetName = (asOf) => `alt:${asOf}`;
/** The report date behind an alternative investment's month row, or null for any other row. */
export function altReportDateOf(sheetName) {
    const m = /^alt:(\d{4}-\d{2}-\d{2})$/.exec(sheetName ?? '');
    return m ? m[1] : null;
}
/** "לפי דוח 30.09.2026" — the marker shown next to a carried-forward value. */
export function altReportLabel(asOf) {
    const [y, m, d] = asOf.split('-');
    return `לפי דוח ${d}.${m}.${y}`;
}
/** The note shown wherever the portfolio benchmark appears next to alternatives. */
export const ALT_BENCHMARK_NOTE_HE = 'מדד הייחוס אינו כולל השקעות אלטרנטיביות';
/** The fields the reader returns a quote and a location for. */
export const ALT_FIELDS = ['investment_name', 'as_of', 'nav', 'capital_calls', 'distributions', 'currency'];
//# sourceMappingURL=alternatives.js.map